var $ = require('jquery');
var Backbone = require('backbone');

var TemplateCache = require('TemplateCache');


var ResultView = Backbone.View.extend({

	events: {
		'click .arrow.next': 'slideImageNext',
		'click .arrow.prev': 'slideImagePrev',
		'click a, .item': 'openItem',
		'click .alpentraum': 'openItem',
		'click .favable': 'handleFavorite',
		'click .backend-stack': 'handleStack',
	},

	initialize: function() {
		this.rendered = false;
		this.dirty = false;
	},

	render: function() {
		var favorites = typeof window.TraminoFavoriten !== "undefined" ? TraminoFavoriten.getItemsMap() : {};
		this.fav_key = 'clients-' + this.model.get("id");

		this.el.innerHTML = TemplateCache.render('result-template', {
			result: this.model.toJSON(),
			app: this.app,
			favorited: (typeof favorites[this.fav_key] !== "undefined"),
		});
		/* Da die Box gefloatet ist, funktionen Funktionen wie .offset() nicht auf dem Parent-Element von Backbone */
		this.$box = this.$el.find('.result-box');
		this.rendered = true;
		this.dirty = false;
		this.shown = false;
	},

	hide: function() {
		//if ( !this.shown ) return; // @todo Debug why this isn't working
		this.$el.detach();
		this.shown = false;
	},

	show: function($list) {
		if ( !this.rendered ) {
			this.render();
		}

		this.$el.appendTo($list);
		//console.warn("Show", this.model.get("name"));
		this.shown = true;
	},

	slideImageNext: function() {
		var $slider = this.$el.find('.slider');
		$slider.children(':last').insertBefore( $slider.children(':first') );
	},

	slideImagePrev: function() {
		var $slider = this.$el.find('.slider');
		$slider.children(':first').insertAfter( $slider.children(':last') );
	},

	openItem: function(e) {
		e.preventDefault();

		/* Nicht bei den Arrows triggern */
		if ( e.target.className.indexOf('arrow') !== -1 ) return;
		/* Auch nicht bei Favoriten */
		if ( e.target.className.indexOf('favable') !== -1 ) return;
		/* Auch nicht im Backend */
		if ( e.target.className.indexOf('important-tags') !== -1 ) return;

		var item_class = $(e.currentTarget).data('id');
		var item_id = $(e.currentTarget).data('item');
		var append = reservaApp.formModel.getForm();
		if ( item_class ) append['class'] = item_class;
		if ( item_id ) append['item'] = item_id;

		if ( append.rooms == 0 ) append.rooms = 1;

		var tags = this.app.get("selectedTags");
		if ( tags.length ) {
			append.tags = tags.join(",");
		}

		TraminoAnalytics.send(this.model.get("id"), "click");
		window.open(this.$el.find('a').attr('href') + '#?' + $.param(append));
	},

	handleFavorite: function(e) {
		var items = TraminoFavoriten.getItemsMap();
		var promise;
		if ( typeof items[this.fav_key] === "undefined" ) {
			promise = TraminoFavoriten.add({id: this.fav_key});
			TraminoAnalytics.send(this.model.get("id"), "favorite");
		} else {
			promise = TraminoFavoriten.remove(this.fav_key);
		}
		promise.then(function() {
			/* Wir müssen den View neu erzeugen, da dieser gerade nicht im DOM sein könnte, wenn "Header Favoriten" das aktualisiert. */
			this.render();
		}.bind(this));
	},

	handleStack: function(e) {
		e.preventDefault(); e.stopImmediatePropagation();
		var btn = $(e.currentTarget);
		var item = btn.data("item");

		if ( !this.app.userStackExists(item) ) {
			this.app.userStackAdd(item, { item: item });
			btn.addClass('active');
		} else {
			this.app.userStackRemove(item);
			btn.removeClass('active');
		}
	},

	/* Create a copy of this view (needed for Google Maps) */
	clone: function() {
		var view = new ResultView({
			model: this.model,
		});
		view.app = this.app;
		return view;
	},

});

module.exports = ResultView;



// WEBPACK FOOTER //
// /Users/bm/app/code/jsapps/modules/reserva/engine/views/ResultView.js